<style lang="scss" scoped>
	.p-news-detail {
		width: 100%;
		height: auto;
		overflow: auto;
		background: url('../../assets/pc/p-news-detail-bg.png');
	}
	.p-news-detail-title {
		display: block;
		margin: 160px auto 30px auto;
	}
	.content {
		width: 1547px;
		height: auto;
		overflow: auto;
		margin: 0 auto;
		margin-bottom: 150px;
	}
	.content-top {
		position: relative;
		width: 100%;
		height: 200px;
		background: url('../../assets/pc/p-news-detail-ct-top.png');
		text-align: center;
		.back-btn {
			position: absolute;
			top: 67px;
    	right: 235px;
			cursor: pointer;
		}
		.news-title {
			position: absolute;
			top: 115px;
			left: 233px;
			width: 1100px;
			height: 60px;
			line-height: 60px;
			color: #bd4f67;
			font-size: 24px;
			text-shadow: 0 0 1px #bd4f67;
			letter-spacing: 2px;
		}
	}
	.content-center {
		width: 100%;
		min-height: 800px;
		overflow: auto;
		background: url('../../assets/pc/p-news-detail-ct-center.png');
		box-sizing: border-box;
    padding-left: 232px;
    padding-right: 212px;
	}
</style>

<template>
	<div class="p-news-detail">
		<img class="p-news-detail-title" src="../../assets/pc/p-news-detail-title.png" alt="title">
		<div class="content">
			<div class="content-top">
				<img class="back-btn" @click="$router.go(-1)" src="../../assets/pc/back.png" alt="back">
				<div class="news-title">{{newsTitle}}</div>
			</div>
			<div class="content-center ql-editor" v-html="newsValue"></div>
			<img src="../../assets/pc/p-news-detail-ct-bottom.png" alt="">
		</div>
	</div>
</template>

<script>
export default {
	name: 'p-news-detail',
	data() {
		return {
			newsTitle: '',
			newsAuthor: '',
			newsPublishDate: '',
			newsValue: ''
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			const newsId = this.$route.params.newsId;
			this.$http.get('/api/website/getNews?newsId=' + newsId).then((rsp) => {
				this.newsTitle = rsp.result.news.newsTitle;
				this.newsAuthor = rsp.result.news.newsAuthor;
				this.newsPublishDate = rsp.result.news.newsPublishDate;
				this.newsValue = rsp.result.news.newsValue;
			});
		}
	},
}
</script>